const deltaThreshold = 0.1
const deltaActiveThreshold = 5

export class LongTaskMonitor {
  lastDelta = 0
  lastTimestamp = 0

  detect(): boolean {
    if (typeof performance?.now !== 'function') return false
    if (this.lastTimestamp === 0) {
      this.lastTimestamp = performance.now()
      return false
    }
    if (this.lastDelta === 0) {
      const now = performance.now()
      this.lastDelta = now - this.lastTimestamp
      this.lastTimestamp = now
      return false
    }
    const now = performance.now()
    const delta = now - this.lastTimestamp
    const longTask =
      this.lastDelta > deltaActiveThreshold &&
      delta / this.lastDelta - 1 > deltaThreshold
    this.lastDelta = Math.max(delta, this.lastDelta)
    this.lastTimestamp = now
    return longTask
  }
}
